const staticText = {
  inputError: 'Please enter email(s) in the proper email format.',
  duplicateEmailError: 'Please remove duplicate emails',
  removeUserEmail: 'Please remove your own email before continuing',
  inputLabel: 'Emails',
  inputPlaceholder: 'Enter email addresses',
};

export default staticText;
